// extracted by mini-css-extract-plugin
export default {"brandPromo":"fI-z","carousel":"gI-z"};